/**
 * RunnerPage — the game entry. Replaces the old arcade select screen: going to
 * /games drops you straight into the branded loader and then the game.
 *
 * The heavy game (three.js + drei + GLB models) is code-split via React.lazy,
 * so it only downloads when someone actually opens the game. GameLoader covers
 * the whole load (chunk + models) and fades out once EndlessRunner signals it
 * has finished loading its assets (onReady). A failsafe timer makes sure the
 * loader never sticks if a model load hangs.
 */
import React, { Suspense, lazy, useEffect, useState } from 'react';
import GameLoader from './GameLoader';
import PageMeta from '../../components/PageMeta';

const EndlessRunner = lazy(() => import('./EndlessRunner'));

export default function RunnerPage() {
  const [gameReady, setGameReady] = useState(false);
  const [loaderDone, setLoaderDone] = useState(false);

  // Failsafe: never let the loader hang forever if asset loading stalls.
  useEffect(() => {
    const t = setTimeout(() => setGameReady(true), 9000);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      {/* Without this the tab (and every shared link) still reads
          "Professioneller Video Editor" from index.html. */}
      <PageMeta
        title="Arcade | DAVIDMEDIA"
        description="Das DAVIDMEDIA-Arcade: ein 3D-Endless-Runner direkt im Browser."
        url="https://www.davidmedia.de/games"
      />
      <Suspense fallback={null}>
        <EndlessRunner onReady={() => setGameReady(true)} />
      </Suspense>
      {!loaderDone && (
        <GameLoader ready={gameReady} onDone={() => setLoaderDone(true)} />
      )}
    </>
  );
}
